import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styled from 'styled-components';
import Row from '../../shared/atoms/Row';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Button from '../../shared/atoms/Button';
import Upload16 from '../../icons/Upload16';
import Copy16 from '../../icons/Copy16';
import Check16 from '../../icons/Check16';

const StyledBox = styled(Box)`
  z-index: 0;
  position: relative;
  overflow: hidden;
`;
const StyledRow = styled(Row)`
  z-index: 2;
  align-items: center;
`;

function Sponsorship({
  referCode,
  codeExpiration,
  setShareModal,
  onGenerateCode,
  isGenerating,
  ...props
}) {
  const { t } = useTranslation();
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      // Fallback for non-secure contexts (HTTP)
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    setIsCopiedToClipboard(true);
    setTimeout(() => {
      setIsCopiedToClipboard(false);
    }, 2000);
  };

  const formatExpirationDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  if (!referCode) {
    return (
      <StyledBox
        bg="orange.lighter"
        borderRadius="sm"
        p={{ xs: 4, lg: 5 }}
        mb={{ xs: 6, lg: 9 }}>
        <StyledRow md gap={24}>
          <Box style={{ flex: 2 }}>
            <Text>
              <Trans i18nKey="sponsorship.subeahding" />
            </Text>
          </Box>
          <Box>
            <Button
              fullWidth
              size="compact"
              variant="filledWhite"
              onClick={onGenerateCode}
              disabled={isGenerating}>
              {isGenerating
                ? t('sponsorship.generating', 'Génération...')
                : t('sponsorship.generate', 'Générer mon code de parrainage')}
            </Button>
          </Box>
        </StyledRow>
      </StyledBox>
    );
  }

  return (
    <StyledBox
      bg="orange.lighter"
      borderRadius="sm"
      p={{ xs: 4, lg: 5 }}
      mb={{ xs: 6, lg: 9 }}>
      <StyledRow md gap={24}>
        <Box style={{ flex: 2 }}>
          <Text>
            <Trans i18nKey="sponsorship.subeahding" />
          </Text>
        </Box>
        <Box>
          <Box
            bg="orange.lighter"
            borderRadius="sm"
            flexDirection="row"
            borderStyle="dashed"
            borderWidth="1px"
            borderColor="yellow.dark"
            alignItems="center"
            mb={2}
            p={2}
            onClick={() => copyToClipboard(referCode)}
            style={{ cursor: 'pointer' }}>
            <Text
              fontWeight={2}
              color="black"
              textAlign="center"
              style={{ width: '100%' }}>
              {referCode}
            </Text>
            {isCopiedToClipboard ? (
              <Check16 style={{ position: 'absolute', right: 35 }} />
            ) : (
              <Copy16 style={{ position: 'absolute', right: 35 }} />
            )}
          </Box>
          {codeExpiration && (
            <Text fontSize={0} color="gray.dark" mb={2} textAlign="center">
              {t('sponsorship.expires', {
                date: formatExpirationDate(codeExpiration),
              })}
            </Text>
          )}
          <Button
            fullWidth
            size="compact"
            variant="filledWhite"
            before={<Upload16 />}
            onClick={() => setShareModal(true)}>
            {' '}
            {t('sponsorship.sharecode')}
          </Button>
          <Text fontSize={0} color="gray.dark" mt={2} textAlign="center">
            {t('sponsorship.single_use', 'Ce code est à usage unique')}
          </Text>
        </Box>
      </StyledRow>
    </StyledBox>
  );
}

export default Sponsorship;
